import React from 'react'
import { PopoverHeader as ReactStrapPopoverHeader, PopoverHeaderProps as ReactStrapPopoverHeaderProps } from 'reactstrap'

export const PopoverHeader = (props: ReactStrapPopoverHeaderProps) => <ReactStrapPopoverHeader {...props} />
